"use client";

import { createElement, type ReactNode } from "react";
import { AdminScreenBoundary } from "@zzk/admin";
import { createClientErrorReporter } from "@zzk/ui";
import { ServerErrorPage } from "@zzk/admin-pages";
import { brandConfig } from "./brand/index.js";

type WindowWithEnv = { readonly __ZZK_ENV__?: string };

export function resolveEnvironment(): string {
  return (globalThis as WindowWithEnv).__ZZK_ENV__ ?? "production";
}

export function buildErrorReporter() {
  return createClientErrorReporter({
    endpoint: "/_zzk/client-errors",
    fetcher: (url, init) =>
      fetch(url, init).then((r) => ({ ok: r.ok, status: r.status })),
    context: {
      app: brandConfig.name,
      environment: resolveEnvironment(),
    },
  });
}

export function renderErrorFallback() {
  return ServerErrorPage({ retryHref: "/app" });
}

export interface AdminErrorBoundaryProps {
  readonly children?: ReactNode;
}

export function AdminErrorBoundary({ children }: AdminErrorBoundaryProps) {
  return createElement(
    AdminScreenBoundary,
    {
      reporter: buildErrorReporter(),
      source: { component: "AdminErrorBoundary" },
      context: {
        app: brandConfig.name,
        environment: resolveEnvironment(),
      },
      fallback: renderErrorFallback,
    },
    children,
  );
}
